import {FormField, Input, InputField} from "@hosttools/frontend/components";
import useChannel from "@hosttools/frontend/react/hooks/useChannel";
import type React from "react";
import {memo, useCallback} from "react";

import type {CredentialsType, Errors} from "@/admin/components/ModalAddAccount/types";

export type Props = {
    credentials: CredentialsType;
    errors?: Errors;
    onChangeCredentials: (field: "username" | "password", value: string) => void;
};

const AugustCredential: React.FC<Props> = ({credentials, errors, onChangeCredentials}) => {
    const {label} = useChannel("August");

    const handleChangeUsername = useCallback(
        (text: string) => {
            onChangeCredentials("username", text);
        },
        [onChangeCredentials]
    );

    const handleChangePassword = useCallback(
        (text: string) => {
            onChangeCredentials("password", text);
        },
        [onChangeCredentials]
    );

    return (
        <>
            <FormField
                error={errors?.username}
                label={`${label} Email`}
                tooltip={`Enter the email address you use to login to your ${label} account.`}
            >
                <Input isRequired>
                    <InputField
                        autoComplete="off"
                        id="username"
                        name="username"
                        placeholder={`${label} Email...`}
                        type="text"
                        value={credentials.username}
                        onChangeText={handleChangeUsername}
                    />
                </Input>
            </FormField>
            <FormField
                error={errors?.password}
                label={`${label} Password`}
                tooltip={`Enter your ${label} password.`}
            >
                <Input isRequired>
                    <InputField
                        autoComplete="new-password"
                        id="password"
                        name="password"
                        placeholder={`${label} Password...`}
                        type="password"
                        value={credentials.password}
                        onChangeText={handleChangePassword}
                    />
                </Input>
            </FormField>
        </>
    );
};

export default memo(AugustCredential);
